export default "//yastatic.net/s3/distribution/pythia/frontend/_/a419892f5f97dc93483dee3e104817a2.jpeg";